import SvgIcon from '@mui/material/SvgIcon'
import React from 'react'

import { IconProps } from './types'

const IndicatorsIcon: React.FC<IconProps> = (props = {}) => {
  const { color, fontSize, style, ...rest } = props

  return (
    <SvgIcon viewBox="0 0 24 24" style={{ color, fontSize, ...style }} {...rest}>
      <path d="m19.37,9.17H4.63c-.85,0-1.53.69-1.53,1.53v8.87c0,.85.69,1.53,1.53,1.53h14.74c.85,0,1.53-.69,1.53-1.53v-8.87c0-.85-.69-1.53-1.53-1.53Zm-.47,9.94H5.09v-7.94h13.81v7.94Z" />
      <path d="m5.92,8.03h12.15c.55,0,1-.45,1-1s-.45-1-1-1H5.92c-.55,0-1,.45-1,1s.45,1,1,1Z" />
      <path d="m7.47,4.9h9.06c.55,0,1-.45,1-1s-.45-1-1-1H7.47c-.55,0-1,.45-1,1s.45,1,1,1Z" />
    </SvgIcon>
  )
}
export default IndicatorsIcon
